/* global attachEvent */

// **************************************************
// OPEN DROPDOWN [MOBILE]
// **************************************************

attachEvent('.sounds__track-link', 'click', (ev) => {
  ev.preventDefault();
  const selfElement = ev.target.closest('.sounds__track-link');
  const iframeUrl = selfElement.getAttribute('href');
  const iframeElement = document.querySelectorAll('.sounds__iframe iframe')[0];
  iframeElement.src = iframeUrl;
});
